import { memo } from "react";
import "./AccommodationsPricing.scss";
import PropTypes from "prop-types";
import DiscountedPriceSection from "../DiscountedPriceSection/DiscountedPriceSection";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage, FormattedPlural } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";

const AccommodationsPricing = ({ accommodationsPrices }) => {
	if (!accommodationsPrices || accommodationsPrices.length === 0) {
		return null;
	}

	const totalIncludedTaxesForTrip = accommodationsPrices.reduce(
		(total, accommodationPrice) => total + accommodationPrice?.totalIncludedTaxes,
		0
	);

	return (
		<div className="accommodations-pricing">
			<ol className="accommodations-pricing__list">
				{accommodationsPrices.map((accommodationPrice, index) => {
					return (
						<li key={"accommodation-" + index} className="accommodations-pricing__item">
							<Typography
								variant={TYPOGRAPHY_VARIANTS.REGULAR}
								component="span"
								className="accommodations-pricing__item-name"
							>
								{accommodationsPrices.length > 1 ? (
									<FormattedMessage
										id="accommodation.room.number"
										values={{ roomNumber: index + 1 }}
									/>
								) : (
									<FormattedMessage id="quotation.hotel.only.offer.type.label" />
								)}
							</Typography>

							<DiscountedPriceSection
								percentage={accommodationPrice?.discountPercentagePerStay}
								net={accommodationPrice?.initialPricePerStay}
								isBold={false}
								discounted={accommodationPrice?.finalPricePerStayWithoutTaxes}
								typographySize={TYPOGRAPHY_VARIANTS.REGULAR}
								shouldDisplaySuffix={false}
							/>
						</li>
					);
				})}
			</ol>

			{totalIncludedTaxesForTrip > 0 && (
				<aside className="accommodations-pricing__taxes-note">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.SMALL}
						component="p"
						className="accommodations-pricing__taxes-note-text"
					>
						<FormattedPlural
							one={
								<FormattedMessage
									id="accommodation.taxes.included.singular"
									values={{
										amount: (
											<Amount
												value={totalIncludedTaxesForTrip}
												isBold={false}
												size="small"
											/>
										),
									}}
								/>
							}
							other={
								<FormattedMessage
									id="accommodation.taxes.included.plural"
									values={{
										amount: (
											<Amount
												value={totalIncludedTaxesForTrip}
												isBold={false}
												size="small"
											/>
										),
									}}
								/>
							}
							value={accommodationsPrices.length}
						/>
					</Typography>
				</aside>
			)}
		</div>
	);
};

AccommodationsPricing.propTypes = {
	accommodationsPrices: PropTypes.array,
};

export default memo(AccommodationsPricing);
